import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["bold", "className", "element", "forwardedRef", "inverse", "size", "textAlignRight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent, forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { omitBoxProps } from '../box';
import theme from './theme.css';

var InputBase = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputBase, _PureComponent);

  var _super = _createSuper(InputBase);

  function InputBase() {
    _classCallCheck(this, InputBase);

    return _super.apply(this, arguments);
  }

  _createClass(InputBase, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          bold = _this$props.bold,
          className = _this$props.className,
          element = _this$props.element,
          forwardedRef = _this$props.forwardedRef,
          inverse = _this$props.inverse,
          size = _this$props.size,
          textAlignRight = _this$props.textAlignRight,
          otherProps = _objectWithoutProperties(_this$props, _excluded);

      var classNames = cx(theme['input'], theme["is-".concat(size)], (_cx = {}, _defineProperty(_cx, theme['is-inverse'], inverse), _defineProperty(_cx, theme['is-bold'], bold), _defineProperty(_cx, theme['has-text-align-right'], textAlignRight), _cx), className);
      var restProps = omitBoxProps(otherProps);

      var props = _objectSpread({
        className: classNames,
        ref: forwardedRef
      }, restProps);

      return /*#__PURE__*/React.createElement(element, props);
    }
  }]);

  return InputBase;
}(PureComponent);

InputBase.defaultProps = {
  inverse: false,
  disabled: false,
  element: 'input',
  readOnly: false,
  size: 'medium'
};
/** @type {React.ComponentType<any>} */

var ForwardedInputBase = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InputBase, _extends({}, props, {
    forwardedRef: ref
  }));
});
ForwardedInputBase.displayName = 'InputBase';
export default ForwardedInputBase;